// G07 is practice. G08 measures complete arrangements, never partial stone moves.
export default function practiceProgress(game, events) {
  const memory = game.assessment_mode === 'letter_memory';
  const answers = events.filter((event) => event.kind === 'select').map((event) => memory
    ? { selected_id: event.item_id } : { item_id: event.item_id, selected_id: event.selected_id });
  const help = Number(events.some((event) => event.kind === 'help_prompt'));
  let completed = false;
  let summary = { game_id: game.game_id, first_try_correct: 0, total_assessments: 0,
    wrong_selection_count: 0, ...(game.unmeasured_help ? {} : { help_count: help }), completed: false, measurement_type: game.measurement_type };
  if (memory) {
    const letters = Object.fromEntries(game.items.map((item) => [item.id, item.letter]));
    const matched = new Set();
    for (let index = 0; index + 1 < answers.length; index += 2) {
      const first = answers[index].selected_id, second = answers[index + 1].selected_id;
      if (letters[first] === letters[second]) { matched.add(first); matched.add(second); }
    }
    completed = matched.size === game.items.length;
    if (game.source_level !== 4) summary = { ...summary, pair_attempt_count: Math.floor(answers.length / 2), matched_pair_count: matched.size / 2 };
  } else {
    completed = answers.some((answer) => answer.selected_id === game.items[0].target_sequence.join(''));
    summary = { ...summary, first_try_correct: Number(completed && answers.length === 1), total_assessments: 1,
      wrong_selection_count: answers.filter((answer) => answer.selected_id !== 'an').length };
  }
  return { answers, summary: { ...summary, completed }, completed };
}
